import React from 'react';
import { Header } from '../components/Header';
import { Pillars } from '../components/Pillars';
import { SocialFeed } from '../components/SocialFeed';
import { CateringCatalog } from '../components/CateringCatalog';
import { ServiceType } from '../components/Navigation';
import { HalloweekPeekers } from '../components/HalloweekPeekers';
import { SpookyAtmosphere } from '../components/SpookyAtmosphere';
interface HomeProps {
  onScrollToCatalog: () => void;
  onBusinessOrder: () => void;
  onBookTable: () => void;
  onJobs: () => void;
  onOrderClick: (type: ServiceType) => void;
  onHalloweek: () => void;
  businessOrderTrigger: number;
}
export function Home({
  onScrollToCatalog,
  onBusinessOrder,
  onBookTable,
  onJobs,
  onOrderClick,
  onHalloweek,
  businessOrderTrigger
}: HomeProps) {
  return <>
      <SpookyAtmosphere data-id="element-1394" data-mp="3ku8s5slbof1o" />
      <div className="relative w-full" data-id="element-1395" data-mp="3kv0mz173i8qw">
        <HalloweekPeekers onOpen={onHalloweek} data-id="element-1396" data-mp="3owlv698opyur" />
        <Header onScrollToCatalog={onScrollToCatalog} onBusinessOrder={onBusinessOrder} onBookTable={onBookTable} onJobs={onJobs} data-id="element-1397" data-mp="3ovar08bbup34" />
      </div>

      <Pillars data-id="element-1398" data-mp="2vyzydprbkhcx" />

      <div className="w-full max-w-5xl mx-auto space-y-12 md:space-y-24 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-1399" data-mp="2vyhs00ay0mra">
        <CateringCatalog onOrderClick={onOrderClick} businessOrderTrigger={businessOrderTrigger} data-id="element-1400" data-mp="2qwsjosf3un6w" />
        <div className="w-full h-px bg-[#7C8062]/20 max-w-xs mx-auto" data-id="element-1401" data-mp="2hxxb59ol910f" />
        <SocialFeed data-id="element-1402" data-mp="2hz8h9g5iakup" />
      </div>
    </>;
}